import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';

import logo from '../assets/images/logo.svg';
import logoWhite from '../assets/images/logo-white.png';

function Menu() {

    //assigning location variable
    const location = useLocation();

    //destructuring pathname from location
    const { pathname } = location;

    //Javascript split method to get the name of the path in array
    const splitLocation = pathname.split("/");

    const navigate = useNavigate();
    const [showSideMenu, setShowSideMenu] = useState(false);
    const [visibility, setVisibility] = useState(false);

    const handleSideMenuClose = () => {
        setVisibility("");
        setShowSideMenu(false);
    }
    const handleSideMenuShow = () => {
        setVisibility("visibility-hidden");
        setShowSideMenu(true);
    }


    const [navClass, setNavClass] = useState("fixed-top");

  useEffect(() => {

    // scrollDirection();
    pop();
    window.addEventListener('scroll', pop);

    return () => window.removeEventListener('scroll', pop);
  }, []);


//   const scrollDirection = () => {
//     let prevScrollpos = window.pageYOffset;
//     window.onscroll = function () {
//       let currentScrollPos = window.pageYOffset;
//       if (prevScrollpos > currentScrollPos) {
//         // Scrolling up
//         setNavClass("fixed-top");
//       } else {
//         // Scrolling down');
//         setNavClass("bg-transparent");
//       }
//       prevScrollpos = currentScrollPos;
//     }
//   }

  const pop = () => {
    if (window.scrollY > 0) {
      setNavClass("");
      // setNavClass("fixed-top");
    } else {
      setNavClass("bg-transparent");
    }

  }

    return (
        <div className={`position-relative ${visibility}`}>
            {['xxxl'].map((expand) => (
                <Navbar key={expand} expand={expand} className={`bg-body-tertiary custom-navbar fixed-top  ${navClass}`} data-bs-theme="dark" bg="dark" onToggle={handleSideMenuShow} >
                    <Container>
                        <Navbar.Brand href="/" className="d-flex align-items-center justify-content-center">
                            <img src={logo} className="App-logo" alt="logo" />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`}  >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 14 13" fill="none" >
                                <path d="M1 0.5H13M5.5 6.5H13M1 12.5H13" stroke="#F8F8F8" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </Navbar.Toggle>
                        <Navbar.Offcanvas
                            show={showSideMenu} onHide={handleSideMenuClose}
                            id={`offcanvasNavbar-expand-${expand}`}
                            aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                            placement="end"
                        >
                            <Offcanvas.Header>
                                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                                    <img src={logo} className="App-logo" alt="logo" />
                                    <h1 className='sidebar-title'>Menu</h1>
                                </Offcanvas.Title>

                                <Button variant="link" className="ms-auto" onClick={handleSideMenuClose}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M1.5 14.7168L14.935 1.28177" stroke="#F8F8F8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M14.5 14.7178L1.06497 1.28274" stroke="#F8F8F8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </Button>
                            </Offcanvas.Header>
                            <Offcanvas.Body className='px-md-5 px-3'>


                                <Nav className="ms-auto">
                                    <Link className={splitLocation[1] === "" || splitLocation[1] === "home" ? "active nav-link rolling-text" : "nav-link rolling-text"} to="/" onClick={handleSideMenuClose} >
                                        <div className="b
                                        lock"><span className="letter">H</span><span className="letter">o</span><span className="letter">m</span><span className="letter">e</span></div>
                                        <div className="block"><span className="letter">H</span><span className="letter">o</span><span className="letter">m</span><span className="letter">e</span></div>
                                        <span className='menu-count'>01</span>
                                    </Link>
                                    <Link className={splitLocation[1] === "about-us" ? "active nav-link rolling-text" : "nav-link rolling-text"} to="/about-us" onClick={handleSideMenuClose}>
                                        <div className="block">
                                            <span className="letter">A</span>
                                            <span className="letter">b</span>
                                            <span className="letter">o</span>
                                            <span className="letter">u</span>
                                            <span className="letter me-2">t</span>
                                            <span className="letter">U</span>
                                            <span className="letter">s</span>
                                        </div>
                                        <div className="block">
                                            <span className="letter">A</span>
                                            <span className="letter">b</span>
                                            <span className="letter">o</span>
                                            <span className="letter">u</span>
                                            <span className="letter me-2">t</span>
                                            <span className="letter">U</span>
                                            <span className="letter">s</span>
                                        </div>
                                        <span className='menu-count'>02</span>
                                    </Link>

                                    <Link className={splitLocation[1] === "services" ? "active nav-link rolling-text" : "nav-link rolling-text"} to="/services" onClick={handleSideMenuClose}>

                                        <div className="block">
                                            <span className="letter">S</span>
                                            <span className="letter">e</span>
                                            <span className="letter">r</span>
                                            <span className="letter">v</span>
                                            <span className="letter">i</span>
                                            <span className="letter">c</span>
                                            <span className="letter">e</span>
                                            <span className="letter">s</span>
                                        </div>
                                        <div className="block">
                                            <span className="letter">S</span>
                                            <span className="letter">e</span>
                                            <span className="letter">r</span>
                                            <span className="letter">v</span>
                                            <span className="letter">i</span>
                                            <span className="letter">c</span>
                                            <span className="letter">e</span>
                                            <span className="letter">s</span>
                                        </div>
                                        <span className='menu-count'>03</span>
                                    </Link>

                                    <Link className={splitLocation[1] === "our-works" ? "active nav-link rolling-text" : "nav-link  rolling-text"} to="/our-works" onClick={handleSideMenuClose}>
                                        <div className="block">
                                            <span className="letter">O</span>
                                            <span className="letter">u</span>
                                            <span className="letter me-2">r</span>
                                            <span className="letter">W</span>
                                            <span className="letter">o</span>
                                            <span className="letter">r</span>
                                            <span className="letter">k</span>
                                            <span className="letter">s</span>
                                        </div>
                                        <div className="block">
                                            <span className="letter">O</span>
                                            <span className="letter">u</span>
                                            <span className="letter me-2">r</span>
                                            <span className="letter">W</span>
                                            <span className="letter">o</span>
                                            <span className="letter">r</span>
                                            <span className="letter">k</span>
                                            <span className="letter">s</span>
                                        </div>
                                        <span className='menu-count'>04</span>
                                    </Link>

                                    <Link className={splitLocation[1] === "case-study" ? "active nav-link rolling-text" : "nav-link  rolling-text"} to="/case-study" onClick={handleSideMenuClose}>
                                        <div className="block">
                                            <span className="letter">C</span>
                                            <span className="letter">a</span>
                                            <span className="letter">s</span>
                                            <span className="letter me-2">e</span>
                                            <span className="letter">S</span>
                                            <span className="letter">t</span>
                                            <span className="letter">u</span>
                                            <span className="letter">d</span>
                                            <span className="letter">y</span>
                                        </div>
                                        <div className="block">
                                           <span className="letter">C</span>
                                            <span className="letter">a</span>
                                            <span className="letter">s</span>
                                            <span className="letter me-2">e</span>
                                            <span className="letter">S</span>
                                            <span className="letter">t</span>
                                            <span className="letter">u</span>
                                            <span className="letter">d</span>
                                            <span className="letter">y</span>
                                        </div>
                                        <span className='menu-count'>05</span>
                                    </Link>

                                    <Link className={splitLocation[1] === "contact-us" ? "active nav-link rolling-text" : "nav-link rolling-text"} to="/contact-us" onClick={handleSideMenuClose}>


                                        <div className="block">
                                            <span className="letter original">C</span>
                                            <span className="letter original">o</span>
                                            <span className="letter original">n</span>
                                            <span className="letter original">t</span>
                                            <span className="letter original">a</span>
                                            <span className="letter original">c</span>
                                            <span className="letter original me-2">t</span>
                                            <span className="letter original">U</span>
                                            <span className="letter original">s</span>
                                        </div>
                                        <div className="block">
                                            <span className="letter original">C</span>
                                            <span className="letter original">o</span>
                                            <span className="letter original">n</span>
                                            <span className="letter original">t</span>
                                            <span className="letter original">a</span>
                                            <span className="letter original">c</span>
                                            <span className="letter original me-2">t</span>
                                            <span className="letter original">U</span>
                                            <span className="letter original">s</span>
                                        </div>
                                        <span className='menu-count'>06</span>
                                    </Link>
                                    <Link className={splitLocation[1] === "careers" ? "active nav-link rolling-text" : "nav-link rolling-text"} to="/careers" onClick={handleSideMenuClose}>
                                        <div className="block">
                                            <span className="letter original">C</span>
                                            <span className="letter original">a</span>
                                            <span className="letter original">r</span>
                                            <span className="letter original">e</span>
                                            <span className="letter original">e</span>
                                            <span className="letter original">r</span>
                                            <span className="letter original">s</span>
                                        </div>
                                        <div className="block">
                                            <span className="letter original">C</span>
                                            <span className="letter original">a</span>
                                            <span className="letter original">r</span>
                                            <span className="letter original">e</span>
                                            <span className="letter original">e</span>
                                            <span className="letter original">r</span>
                                            <span className="letter original">s</span>
                                        </div>
                                        <span className='menu-count'>07</span>
                                    </Link>
                                </Nav>

                            </Offcanvas.Body>
                        </Navbar.Offcanvas>

                    </Container>

                </Navbar>
            ))}
        </div>
    );
}

export default Menu;